import React, {useEffect, useState} from 'react';
import styles from './SwitchButton.module.css';

function SwitchButton({ checked, onToggle }) {

    const handleChange = () => {
        onToggle && onToggle(!checked);
    };

    return (
        <label className={styles.switch}>
            <input type="checkbox" checked={checked} onChange={handleChange} />
            <span className={`${styles.slider} ${styles.round}`}></span>
        </label>
    );
}

export default SwitchButton;